import React from 'react';

import { ReadingFeedbackHistoryEntry } from 'types/objectTypes';
import { formatReadingTime } from 'src/utils/dateHandler';

import styles from './HistoryTab.module.scss';

interface Props {
  isLoading: boolean;
  entries: ReadingFeedbackHistoryEntry[];
}

const withFallback = (value: string) => (value?.trim() ? value : 'n/a');

const HistoryTab: React.FC<Props> = ({ isLoading, entries }) => {
  if (isLoading) {
    return <div className={styles.zeroState}>Loading...</div>;
  }

  if (entries.length === 0) {
    return <div className={styles.zeroState}>No reading feedback to display yet.</div>;
  }

  return (
    <div className={styles.list}>
      {entries.map((entry) => (
        <div key={entry.commentId} className={styles.entry}>
          <div className={styles.row}>
            <span className={styles.label}>Reading Date &amp; Time:</span>
            {' '}
            {entry.readingDate ? formatReadingTime(entry.readingDate) : 'na'}
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Reading topic(s):</span>
            {' '}
            {withFallback(entry.readingTopics)}
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Memory clue:</span>
            {' '}
            {withFallback(entry.memoryClue)}
          </div>
          <div className={styles.row}>
            <span className={styles.label}>People discussed:</span>
            {' '}
            {withFallback(entry.peopleDiscussed)}
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Reading comments:</span>
            {' '}
            {withFallback(entry.readingComments)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HistoryTab;
